import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { IPlatform } from '../model/platform';
import { IReceiver } from '../model/receiver';
import { SpinnerService } from './spinner.service';

@Injectable()
export class PlatformService {

  private platformUrl = environment.apiUrl + '/v1/invoicing-services/';

  /**
   *
   * @param {HttpClient} http
   * @param {SpinnerService} spinnerService
   */
  constructor(private http: HttpClient,
              private spinnerService: SpinnerService) { }

  /**
   *
   * @param identifier
   * @param name
   */
  getPlatforms(identifier: string, name: string = ''): Observable<IPlatform[]> {
    name = name.trim();
    const url = this.platformUrl + `${identifier}/platforms`;
    const options = name ? { params: new HttpParams().set('name', name) } : {};
    this.spinnerService.setSpinner(true);
    return this.http.get<IPlatform[]>(url, options)
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res as IPlatform[];
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

  /**
   *
   * @param identifier
   * @param platform
   */
  savePlatform(identifier: string, platform: IPlatform): Observable<IPlatform> {
    this.spinnerService.setSpinner(true);
    const url = this.platformUrl + `${identifier}/platforms`;
    return this.http.post(url, platform)
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res as IPlatform;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

  /**
   *
   * @param identifier
   * @param platform
   */
  deletePlatform(identifier: string, platform: IPlatform) {
    this.spinnerService.setSpinner(true);
    const url = this.platformUrl + `${identifier}/platforms/${platform.id}`;
    return this.http.delete(url)
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

  /**
   *
   * @param {IPlatform} platform
   * @param {IReceiver[]} receivers
   * @param {string} identifier
   * @return {Observable<any | any>}
   */
  updatePlatform(platform: IPlatform, receivers: IReceiver[], identifier: string) {
    platform.receivers = receivers;
    this.spinnerService.setSpinner(true);
    return this.http.patch(this.platformUrl + `${identifier}/platforms/${platform.id}`, platform)
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/platform.service.ts